<template>
  <div class="container-fluid p-0 px-md-3 mb-5" id="UserDashboard" style="max-width: 1400px;">
    <div>
      <div class="text-center gold mt-4 position-relative">

        <b-button
            v-b-toggle.main_menu
            class="menu-btn d-flex d-xl-flex p-0"
            aria-label="Open menu"
        >
          <i class="fas fa-bars"></i>
        </b-button>


        <h4>
          <i class="fas fa-home"></i> <span class="ml-1" v-text="page_title"></span>
        </h4>
      </div>
      <div>

        <Shortcuts></Shortcuts>

        <!-- ── Main Dashboard: Featured Meditation + Programs ── -->
        <div class="dash-featured-grid mt-5">

          <!-- Programs Panel (right) -->
          <div class="dash-panel dash-panel--programs">
            <div class="dash-panel__header">
              <span class="dash-panel__icon-wrap">
                <i class="fas fa-graduation-cap"></i>
              </span>
              <div class="dash-panel__title-group">
                <span class="dash-panel__title">Continue My Learning</span>
                <span class="dash-panel__subtitle">Your enrolled programs</span>
              </div>
            </div>
            <div class="dash-panel__body dash-panel__body--programs">
              <challenges-card />
            </div>
          </div>

          <!-- Meditation Chart Panel (left) -->
          <div class="dash-panel dash-panel--meditation">
            <div class="dash-panel__header">
              <span class="dash-panel__icon-wrap">
                <meditation-svg class="dash-meditation-icon" />
              </span>
              <span class="dash-panel__title">Meditation</span>
            </div>
            <div class="dash-panel__body">
              <template v-if="meditationChartCard">
                <div v-if="meditationChartCard.overview_text && meditationChartCard.overview_text !== 'undefined'" class="mt-2 mb-3">
                  <ul v-for="(item, index) in meditationChartCard.overview_text" :key="index" class="mb-0 pl-4">
                    <li v-html="item" class="small"></li>
                  </ul>
                </div>
                <div v-if="!meditationChartCard.hasChartData" class="dash-chart-empty">
                  <div class="dash-chart-empty__icon">
                    <i class="fas fa-moon fa-2x"></i>
                  </div>
                  <p class="dash-chart-empty__text">Nothing to show for the last 7 days</p>
                  <router-link to="/meditation_dashboard" class="btn btn-sm dash-btn-gold mt-2">
                    <i class="fas fa-plus mr-1"></i> Log Meditation
                  </router-link>
                </div>
                <div v-else class="dash-chart-canvas">
                  <chart-line :chartdata="meditationChartCard.chartdata" />
                </div>
              </template>
              <div v-else class="dash-chart-empty">
                <div class="dash-chart-empty__icon">
                  <i class="fas fa-moon fa-2x"></i>
                </div>
                <p class="dash-chart-empty__text">No meditation data available</p>
              </div>
            </div>
          </div>
        </div>

        <!-- ── Connections Panel ── -->
        <dashboard-connections class="mt-5"></dashboard-connections>

      </div>
    </div>

    <b-modal
      class="modal-xl" ref="tour" id="tour" title="Website Tour" size="xl" ok-only ok-title="Close"
      @hidden="tourClosed"
    >
      <div class="embed-responsive embed-responsive-16by9">
        <iframe width="560" height="315" src="https://www.youtube.com/embed/ZqUaBS8_bgE" title="YouTube video player" frameborder="0" allow="accelerometer; autoplay; clipboard-write; encrypted-media; gyroscope; picture-in-picture" allowfullscreen></iframe>
      </div>
    </b-modal>
  </div>
</template>

<script>
import axios from '@/axios';
import ChartLine from '../components/ChartLine.vue';
import ChallengesCard from '../components/ChallengesCard.vue';
import Shortcuts from "@/components/Dashboard/Shortcuts";
import DashboardConnections from "@/components/Dashboard/DashboardConnections.vue";
import MeditationSvg from "@/components/svg/MeditationSvg.vue";

export default {
  name: 'UserDashboard',
  components: {
    MeditationSvg,
    DashboardConnections,
    Shortcuts,
    ChartLine,
    ChallengesCard,
  },
  data() {
    return {
      page_title: 'Home',
      meditationChartCard: null,
      connections: null,
      connectionsLoading: true,
    };
  },
  methods: {
    async getMeditationStats() {
      this.meditationChartCard = await axios.get('dashboard/mediation').then(x => x.data)
    },

    tourClosed() {
      axios('regStatusUpdate?reg_status=tour_finished').then(() => {})
    },
  },
  mounted() {
    this.getMeditationStats();

    if (this.$store.state.profile.timezoneOffsetH === null) {
      this.$router.push('/profile');
    }
  },
  watch: {
    $route(to) {
      this.section_title = to.meta.title;
      this.page_title = to.meta.title;
    },
  },
};
</script>

<style scoped>



.menu-btn {
  position: absolute;
  left: 0;
  border: none;
  display: flex;

  &:hover {
    transform: scale(1.06);
    background-color: transparent !important;
    color: inherit !important;
  }

  &:focus,
  &:focus-visible {
    outline: none !important;
    box-shadow: none !important;
  }

  i {
    font-size: 1.4rem !important;
  }
}


/* ── Meditation SVG inside icon wrap ── */
.dash-meditation-icon {
  width: 22px !important;
  height: 22px !important;
}
.dash-meditation-icon /deep/ path,
.dash-meditation-icon /deep/ circle {
  stroke: #fff !important;
}

/* ── Featured two-column layout ── */
.dash-featured-grid {
  display: grid;
  grid-template-columns: 38fr 62fr;
  gap: 20px;
  align-items: stretch;
}

@media (max-width: 991px) {
  .dash-featured-grid {
    grid-template-columns: 1fr;
  }
}

/* ── Panel shell ── */
.dash-panel {
  background: #fff;
  border-radius: 16px;
  box-shadow: 0 4px 20px rgba(0,0,0,0.07);
  border: 1px solid rgba(214,182,116,0.18);
  border-bottom: none;
  overflow: hidden;
  display: flex;
  flex-direction: column;
}

/* ── Panel header bar ── */
.dash-panel__header {
  display: flex;
  align-items: center;
  gap: 10px;
  padding: 14px 18px;
  background: transparent;
  border-bottom: 1px solid rgba(214,182,116,0.18);
}

.dash-panel__icon-wrap {
  width: 32px;
  height: 32px;
  border-radius: 50%;
  background: linear-gradient(135deg, #d6b674 0%, #c4a55a 100%);
  display: flex;
  align-items: center;
  justify-content: center;
  color: #fff;
  font-size: 0.95rem;
  flex-shrink: 0;
}

.dash-panel__title-group {
  display: flex;
  flex-direction: column;
  gap: 1px;
}

.dash-panel__title {
  font-weight: 700;
  font-size: 1rem;
  color: #333;
  letter-spacing: 0.3px;
  line-height: 1.2;
}

.dash-panel__subtitle {
  font-size: 0.7rem;
  color: #aaa;
  letter-spacing: 0.2px;
}

.dash-panel__link {
  font-size: 0.75rem;
  color: #d6b674;
  text-decoration: none;
  white-space: nowrap;
  border: 1px solid rgba(214,182,116,0.45);
  border-radius: 20px;
  padding: 3px 10px;
  transition: background 0.18s, color 0.18s;
}
.dash-panel__link:hover {
  background: linear-gradient(135deg, #d6b674 0%, #c4a55a 100%);
  color: #fff;
  text-decoration: none;
}

/* ── Panel body ── */
.dash-panel__body {
  padding: 18px;
  flex: 1;
}
.dash-panel__body--programs {
  padding: 12px 14px;
  max-height: 480px;
  overflow-y: auto;
  overflow-x: hidden;
}

.dash-panel__body--programs::-webkit-scrollbar {
  width: 5px;
}
.dash-panel__body--programs::-webkit-scrollbar-track {
  background: rgba(214,182,116,0.08);
}
.dash-panel__body--programs::-webkit-scrollbar-thumb {
  background: rgba(214,182,116,0.5);
  border-radius: 4px;
}

/* ── Meditation chart ── */
.dash-chart-empty {
  display: flex;
  flex-direction: column;
  align-items: center;
  justify-content: center;
  min-height: 240px;
  background: linear-gradient(135deg, rgba(214,182,116,0.07) 0%, rgba(196,165,90,0.09) 100%);
  border-radius: 12px;
  border: 1px dashed rgba(214,182,116,0.35);
}
.dash-chart-empty__icon {
  width: 60px;
  height: 60px;
  border-radius: 50%;
  background: #fff;
  border: 1px solid rgba(214,182,116,0.3);
  display: flex;
  align-items: center;
  justify-content: center;
  color: #d6b674;
  margin-bottom: 12px;
  box-shadow: 0 2px 8px rgba(214,182,116,0.15);
}
.dash-chart-empty__text {
  color: #888;
  font-size: 0.88rem;
  margin: 0;
}
.dash-chart-canvas {
  min-height: 240px;
  width: 100%;
  background: linear-gradient(135deg, rgba(214,182,116,0.08) 0%, rgba(196,165,90,0.10) 100%);
  border-radius: 12px;
  padding: 12px;
}

/* ── Gold outline button ── */
.dash-btn-gold {
  background: transparent;
  border: 1px solid #d6b674;
  color: #d6b674;
  border-radius: 20px;
  font-size: 0.8rem;
  padding: 4px 14px;
  transition: all 0.18s;
}
.dash-btn-gold:hover {
  background: linear-gradient(135deg, #d6b674 0%, #c4a55a 100%);
  color: #fff;
}

.dash-panel__body--connections {
  padding: 20px 24px;
  max-height: 420px;
  overflow-y: auto;
  overflow-x: hidden;
}

.dash-panel__body--connections::-webkit-scrollbar {
  width: 5px;
}
.dash-panel__body--connections::-webkit-scrollbar-track {
  background: rgba(214,182,116,0.08);
}
.dash-panel__body--connections::-webkit-scrollbar-thumb {
  background: rgba(214,182,116,0.5);
  border-radius: 4px;
}

.conn-empty {
  display: flex;
  flex-direction: column;
  align-items: center;
  justify-content: center;
  min-height: 160px;
}

/* ── Connection card grid ── */
.conn-grid {
  display: flex;
  flex-direction: column;
  gap: 10px;
}

.conn-card {
  display: flex;
  align-items: center;
  gap: 12px;
  width: 100%;
  background: #fff;
  border: 1px solid rgba(214,182,116,0.18);
  border-radius: 12px;
  padding: 12px 16px;
  box-shadow: 0 2px 10px rgba(0,0,0,0.05);
  transition: transform 0.15s ease, box-shadow 0.18s ease;
  position: relative;
  overflow: hidden;
}

.conn-card::before {
  content: '';
  position: absolute;
  left: 0; top: 0; bottom: 0;
  width: 3px;
  border-radius: 12px 0 0 12px;
  background: linear-gradient(180deg, #d6b674 0%, #c4a55a 100%);
}

.conn-card:hover {
  transform: translateY(-2px);
  box-shadow: 0 6px 20px rgba(214,182,116,0.18);
}

/* Avatar */
.conn-card__avatar-wrap {
  position: relative;
  flex-shrink: 0;
}

.conn-card__avatar {
  width: 42px;
  height: 42px;
  border-radius: 50%;
  object-fit: cover;
  border: 2px solid rgba(214,182,116,0.3);
  display: block;
  transition: border-color 0.2s;
}

.conn-card:hover .conn-card__avatar {
  border-color: #d6b674;
}

.conn-card__dot {
  position: absolute;
  bottom: 1px;
  right: 1px;
  width: 11px;
  height: 11px;
  border-radius: 50%;
  border: 2px solid #fff;
}

.conn-card__dot--on  { background: #28a745; }
.conn-card__dot--off { background: #ccc; }

/* Info */
.conn-card__info {
  flex: 1;
  min-width: 0;
  display: flex;
  flex-direction: column;
  gap: 2px;
}

.conn-card__name {
  font-weight: 600;
  font-size: 0.88rem;
  color: #333;
  text-decoration: none;
  white-space: nowrap;
  overflow: hidden;
  text-overflow: ellipsis;
  display: block;
  transition: color 0.18s;
}

.conn-card__name:hover {
  color: #d6b674;
  text-decoration: none;
}

.conn-card__status-label {
  font-size: 0.7rem;
  color: #aaa;
}

/* Chat button */
.conn-card__chat {
  flex-shrink: 0;
  width: 34px;
  height: 34px;
  border-radius: 50%;
  background: linear-gradient(135deg, rgba(214,182,116,0.12) 0%, rgba(196,165,90,0.15) 100%);
  display: flex;
  align-items: center;
  justify-content: center;
  color: #d6b674;
  font-size: 0.95rem;
  text-decoration: none;
  transition: background 0.18s, color 0.18s, transform 0.15s;
  border: 1px solid rgba(214,182,116,0.25);
}

.conn-card__chat:hover {
  background: linear-gradient(135deg, #d6b674 0%, #c4a55a 100%);
  color: #fff;
  transform: scale(1.1);
  text-decoration: none;
}

</style>
